var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Drawers", {
        attrs: { drawers: _vm.drawer },
        on: { drawerVisible: _vm.handleClose, fatherMethods: _vm.getfun1 },
        scopedSlots: _vm._u([
          {
            key: "desc",
            fn: function () {
              return [
                _c(
                  "el-tabs",
                  {
                    model: {
                      value: _vm.drawer.activeName,
                      callback: function ($$v) {
                        _vm.$set(_vm.drawer, "activeName", $$v)
                      },
                      expression: "drawer.activeName",
                    },
                  },
                  [
                    _c(
                      "el-tab-pane",
                      { attrs: { label: "基本信息", name: "1" } },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "info_conts",
                            style: "height:" + _vm.height + "px",
                          },
                          [
                            _c("div", { staticClass: "info_titleimg" }, [
                              _vm.drawer.info.cover != ""
                                ? _c(
                                    "div",
                                    { staticStyle: { "text-align": "center" } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "info_card_imgs" },
                                        [
                                          !_vm.coverImgInfo.url
                                            ? _c("img", {
                                                staticClass: "info_card_img",
                                                attrs: {
                                                  src: "https://scpcm.oss-cn-hangzhou.aliyuncs.com/static/pc/coverImg/direct.png",
                                                },
                                              })
                                            : _vm._e(),
                                          _vm.coverImgInfo.url
                                            ? _c("img", {
                                                staticClass: "info_card_img",
                                                attrs: {
                                                  src: _vm.coverImgInfo.url,
                                                },
                                                on: {
                                                  error: _vm.setDefaultImage,
                                                },
                                              })
                                            : _vm._e(),
                                        ]
                                      ),
                                      _vm.drawer.info.editFlag &&
                                      _vm.drawer.info.delFlag != "2"
                                        ? _c(
                                            "div",
                                            {
                                              on: { click: _vm.coverImgDialog },
                                            },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  staticClass: "upload_btn",
                                                  attrs: {
                                                    icon: "iconfont icon-daochu upload_icon",
                                                  },
                                                },
                                                [_vm._v("上传封面")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.drawer.info.editFlag &&
                              _vm.drawer.info.delFlag != "2" &&
                              _vm.drawer.info.cover == ""
                                ? _c("div", [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "upload_box",
                                        on: { click: _vm.coverImg },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "iconfont icon-daochu upload_icon",
                                        }),
                                        _c("div", [_vm._v("上传封面")]),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _c("div", { staticClass: "info" }, [
                              _c(
                                "div",
                                { staticClass: "info_key" },
                                [
                                  _c("div", {
                                    staticStyle: { "margin-left": "11px" },
                                  }),
                                  _c("i", {
                                    staticClass: "iconfont icon-task info_icon",
                                    staticStyle: { "font-size": "12px" },
                                  }),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        effect: "dark",
                                        content: "项目名称",
                                        placement: "bottom",
                                        "popper-class": "texttooltip",
                                      },
                                    },
                                    [_c("div", [_vm._v("项目名称")])]
                                  ),
                                ],
                                1
                              ),
                              _vm.drawer.info.editFlag &&
                              _vm.drawer.info.delFlag != "2" &&
                              _vm.edit_input == "input_name"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "info_value",
                                      staticStyle: {
                                        width: "calc(100% - 282px)!important",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.permissionsChange(
                                            "input_name"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        ref: "input_name",
                                        attrs: {
                                          autofocus: true,
                                          placeholder: "点击添加",
                                        },
                                        on: { blur: _vm.editTaskChange },
                                        model: {
                                          value: _vm.proname,
                                          callback: function ($$v) {
                                            _vm.proname = $$v
                                          },
                                          expression: "proname",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c(
                                    "div",
                                    {
                                      class: _vm.drawer.info.editFlag
                                        ? "info_valueEditFlag"
                                        : "info_value",
                                      staticStyle: {
                                        width: "calc(100% - 282px) !important",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.permissionsChange(
                                            "input_name"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "info_value_text" },
                                        [_vm._v(_vm._s(_vm.proname))]
                                      ),
                                    ]
                                  ),
                            ]),
                            _c("div", { staticClass: "info" }, [
                              _c(
                                "div",
                                { staticClass: "info_key" },
                                [
                                  _c("div", {
                                    staticStyle: { "margin-left": "11px" },
                                  }),
                                  _c("i", {
                                    staticClass:
                                      "iconfont icon-bianhao info_icon",
                                    staticStyle: { "font-size": "19px" },
                                  }),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        effect: "dark",
                                        content: "项目编号",
                                        placement: "bottom",
                                        "popper-class": "texttooltip",
                                      },
                                    },
                                    [_c("div", [_vm._v("项目编号")])]
                                  ),
                                ],
                                1
                              ),
                              _vm.drawer.info.editFlag &&
                              _vm.drawer.info.delFlag != "2" &&
                              _vm.edit_input == "input_serial"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "info_value",
                                      staticStyle: {
                                        width: "calc(100% - 282px)!important",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.permissionsChange(
                                            "input_serial"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        ref: "input_serial",
                                        attrs: { placeholder: "点击添加" },
                                        on: { blur: _vm.editTaskChange },
                                        model: {
                                          value: _vm.proNumber,
                                          callback: function ($$v) {
                                            _vm.proNumber = $$v
                                          },
                                          expression: "proNumber",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c(
                                    "div",
                                    {
                                      class: _vm.drawer.info.editFlag
                                        ? "info_valueEditFlag"
                                        : "info_value",
                                      staticStyle: {
                                        width: "calc(100% - 282px) !important",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.permissionsChange(
                                            "input_serial"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "info_value_text" },
                                        [_vm._v(_vm._s(_vm.proNumber))]
                                      ),
                                    ]
                                  ),
                            ]),
                            _c("div", { staticClass: "info" }, [
                              _c(
                                "div",
                                { staticClass: "info_key" },
                                [
                                  _c("div", {
                                    staticStyle: { "margin-left": "11px" },
                                  }),
                                  _c("i", {
                                    staticClass: "iconfont icon-type info_icon",
                                    staticStyle: { "font-size": "13px" },
                                  }),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        effect: "dark",
                                        content: "表单类型",
                                        placement: "bottom",
                                        "popper-class": "texttooltip",
                                      },
                                    },
                                    [_c("div", [_vm._v("表单类型")])]
                                  ),
                                ],
                                1
                              ),
                              _vm.drawer.info.editFlag &&
                              _vm.drawer.info.delFlag != "2" &&
                              _vm.edit_input == "input_form"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "info_value",
                                      staticStyle: { height: "35px" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.permissionsChange(
                                            "input_form",
                                            "select"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          ref: "input_form",
                                          attrs: {
                                            filterable: "",
                                            placeholder: "请选择表单类型",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.editTaskChange("form")
                                            },
                                          },
                                          model: {
                                            value: _vm.drawer.info.formId,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.drawer.info,
                                                "formId",
                                                $$v
                                              )
                                            },
                                            expression: "drawer.info.formId",
                                          },
                                        },
                                        _vm._l(_vm.formList, function (item) {
                                          return _c("el-option", {
                                            key: item.id,
                                            attrs: {
                                              label: item.formName,
                                              value: item.id,
                                            },
                                          })
                                        }),
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _c(
                                    "div",
                                    {
                                      class: _vm.drawer.info.editFlag
                                        ? "info_valueEditFlag"
                                        : "info_value",
                                      staticStyle: {
                                        height: "35px",
                                        width: "calc(100% - 282px) !important",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.permissionsChange(
                                            "input_form",
                                            "select"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm.drawer.info.formId
                                        ? _c(
                                            "div",
                                            { staticClass: "info_value_text" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        _vm.drawer.info.form
                                                          .id ==
                                                        _vm.drawer.info.formId,
                                                      expression:
                                                        "drawer.info.form.id == drawer.info.formId",
                                                    },
                                                  ],
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.drawer.info.form
                                                        .formName
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            { staticClass: "info_value_text" },
                                            [_vm._v("标准表单")]
                                          ),
                                    ]
                                  ),
                            ]),
                            _c("div", { staticClass: "info" }, [
                              _c(
                                "div",
                                { staticClass: "info_key" },
                                [
                                  _c("div", {
                                    staticStyle: { "margin-left": "11px" },
                                  }),
                                  _c("i", {
                                    staticClass:
                                      "iconfont icon-fuzeren info_icon",
                                  }),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        effect: "dark",
                                        content: "负责人",
                                        placement: "bottom",
                                        "popper-class": "texttooltip",
                                      },
                                    },
                                    [_c("div", [_vm._v("负责人")])]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  class: _vm.drawer.info.editFlag
                                    ? "info_valueEditFlag"
                                    : "info_value",
                                },
                                [
                                  !_vm.drawer.info.editFlag ||
                                  _vm.drawer.info.delFlag == "2"
                                    ? _c(
                                        "div",
                                        { staticClass: "personnel" },
                                        _vm._l(
                                          _vm.drawer.principalUsers,
                                          function (item, index) {
                                            return _c(
                                              "div",
                                              {
                                                key: index,
                                                staticClass:
                                                  "info_personnel info_value_text",
                                              },
                                              [
                                                item.avatar != "" &&
                                                item.avatar !== null
                                                  ? _c("img", {
                                                      staticClass:
                                                        "info_personnel_surname",
                                                      attrs: {
                                                        src: item.avatar,
                                                      },
                                                    })
                                                  : _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "info_personnel_surname",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.name.substring(
                                                              0,
                                                              1
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                _vm.channel === "wechat"
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _c("ww-open-data", {
                                                          attrs: {
                                                            type: "userName",
                                                            openid: item.name,
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    )
                                                  : _c("div", [
                                                      _vm._v(_vm._s(item.name)),
                                                    ]),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    : _c("div", { staticClass: "add_text" }, [
                                        _c(
                                          "div",
                                          { staticClass: "info_box" },
                                          [
                                            _vm._l(
                                              _vm.drawer.principalUsers,
                                              function (item, index) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass:
                                                      "info_personnel",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.contactCh(
                                                          _vm.drawer
                                                            .principalUsers,
                                                          0
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    item.avatar != "" &&
                                                    item.avatar !== null
                                                      ? _c("img", {
                                                          staticClass:
                                                            "info_personnel_surname",
                                                          attrs: {
                                                            src: item.avatar,
                                                          },
                                                        })
                                                      : _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "info_personnel_surname",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.name.substring(
                                                                  0,
                                                                  1
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                    _vm.channel === "wechat"
                                                      ? _c(
                                                          "div",
                                                          [
                                                            _c("ww-open-data", {
                                                              attrs: {
                                                                type: "userName",
                                                                openid:
                                                                  item.name,
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        )
                                                      : _c("div", [
                                                          _vm._v(
                                                            _vm._s(item.name)
                                                          ),
                                                        ]),
                                                  ]
                                                )
                                              }
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "iconfont icon-jiahao2fill add_icon",
                                              style:
                                                _vm.drawer.principalUsers &&
                                                _vm.drawer.principalUsers
                                                  .length > 0
                                                  ? "margin: 0 24px;"
                                                  : "margin: 0",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.contactCh(
                                                    _vm.drawer.principalUsers,
                                                    0
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          2
                                        ),
                                      ]),
                                ]
                              ),
                            ]),
                            _c("div", { staticClass: "info" }, [
                              _c(
                                "div",
                                { staticClass: "info_key" },
                                [
                                  _c("div", {
                                    staticStyle: { "margin-left": "11px" },
                                  }),
                                  _c("i", {
                                    staticClass: "iconfont icon-riqi info_icon",
                                    staticStyle: { "font-size": "17px" },
                                  }),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        effect: "dark",
                                        content: "计划时间",
                                        placement: "bottom",
                                        "popper-class": "texttooltip",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.permissionsDateStart(
                                                "input_dateStart"
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("计划时间")]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  class: _vm.drawer.info.editFlag
                                    ? "info_valueEditFlag"
                                    : "info_value",
                                  staticStyle: { width: "calc(100% - 282px)" },
                                },
                                [
                                  _vm.drawer.info.editFlag &&
                                  _vm.drawer.info.delFlag != "2" &&
                                  _vm.edit_input == "input_dateStart"
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: { width: "47%" },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.permissionsDateStart(
                                                "input_dateStart"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("el-date-picker", {
                                            ref: "input_dateStart",
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              type: "date",
                                              placeholder: "点击添加",
                                              "value-format":
                                                "yyyy/MM/dd HH:mm:ss",
                                              format: "yyyy/MM/dd",
                                              clearable: false,
                                              "picker-options":
                                                _vm.pickerOptions,
                                            },
                                            on: { blur: _vm.editTaskChange },
                                            model: {
                                              value:
                                                _vm.drawer.info.planStartDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.drawer.info,
                                                  "planStartDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "drawer.info.planStartDate",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticClass: "info_value_text",
                                          staticStyle: {
                                            width: "calc(47% - 12px)",
                                            height: "35px",
                                            cursor: "pointer",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.permissionsDateStart(
                                                "input_dateStart"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.drawer.info.planStartDate
                                                ? _vm.drawer.info.planStartDate.substring(
                                                    0,
                                                    10
                                                  )
                                                : ""
                                            )
                                          ),
                                        ]
                                      ),
                                  _vm.drawer.info.planStartDate &&
                                  _vm.drawer.info.planStartDate
                                    ? _c(
                                        "div",
                                        { staticStyle: { color: "#909090" } },
                                        [_vm._v("-")]
                                      )
                                    : _vm._e(),
                                  _vm.drawer.info.editFlag &&
                                  _vm.drawer.info.delFlag != "2" &&
                                  _vm.edit_input == "input_dateEnd"
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: { width: "47%" },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.permissionsDateEnd(
                                                "input_dateEnd"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("el-date-picker", {
                                            ref: "input_dateEnd",
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              type: "date",
                                              placeholder: "点击添加",
                                              "value-format":
                                                "yyyy/MM/dd HH:mm:ss",
                                              format: "yyyy/MM/dd",
                                              clearable: false,
                                              "picker-options":
                                                _vm.pickerOptions1,
                                            },
                                            on: { blur: _vm.editTaskChange },
                                            model: {
                                              value:
                                                _vm.drawer.info.planEndDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.drawer.info,
                                                  "planEndDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "drawer.info.planEndDate",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticClass: "info_value_text",
                                          staticStyle: {
                                            width: "calc(47% - 12px)",
                                            height: "35px",
                                            cursor: "pointer",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.permissionsDateEnd(
                                                "input_dateEnd"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.drawer.info.planEndDate
                                                ? _vm.drawer.info.planEndDate.substring(
                                                    0,
                                                    10
                                                  )
                                                : ""
                                            )
                                          ),
                                        ]
                                      ),
                                ]
                              ),
                            ]),
                            _vm.drawer.info.proTypeId == "0" &&
                            _vm.corpId ===
                              "ding379884b8b194a55f35c2f4657eb6378f"
                              ? _c("div", { staticClass: "info" }, [
                                  _c(
                                    "div",
                                    { staticClass: "info_key" },
                                    [
                                      _c("div", {
                                        staticStyle: { width: "11px" },
                                      }),
                                      _c("i", {
                                        staticClass:
                                          "iconfont icon-riqi info_icon",
                                        staticStyle: { "font-size": "17px" },
                                      }),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "dark",
                                            content: "订金",
                                            placement: "bottom",
                                            "popper-class": "texttooltip",
                                          },
                                        },
                                        [_c("div", [_vm._v("订金")])]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("div", { staticClass: "info_value" }, [
                                    _vm.drawer.info.editFlag &&
                                    _vm.drawer.info.delFlag != "2" &&
                                    _vm.edit_input == "input_dateStartDep"
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: { width: "177px" },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.permissionsDateStartDep(
                                                  "input_dateStartDep"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("el-date-picker", {
                                              ref: "input_dateStartDep",
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                type: "datetime",
                                                "picker-options":
                                                  _vm.pickerOptions,
                                                placeholder: "点击添加",
                                                "value-format":
                                                  "yyyy/MM/dd HH:mm:ss",
                                                format: "yyyy/MM/dd",
                                                clearable: false,
                                                "default-time": "00:00:00",
                                              },
                                              on: {
                                                blur: function ($event) {
                                                  return _vm.editTaskChange(
                                                    "depositDate",
                                                    _vm.drawer.info.depositDate
                                                  )
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.drawer.info.depositDate,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.drawer.info,
                                                    "depositDate",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "drawer.info.depositDate",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "div",
                                          {
                                            class:
                                              _vm.drawer.info.status != "2"
                                                ? "info_valueEditFlag1"
                                                : "info_value_text",
                                            staticStyle: {
                                              width: "100% !important",
                                              height: "35px",
                                              cursor: "pointer",
                                              "margin-left": "11px",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.permissionsDateStartDep(
                                                  "input_dateStartDep"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm.drawer.info.depositDate
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.drawer.info.depositDate.substring(
                                                        0,
                                                        10
                                                      )
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        ),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm.drawer.info.proTypeId == "0" &&
                            _vm.corpId ===
                              "ding379884b8b194a55f35c2f4657eb6378f"
                              ? _c("div", { staticClass: "info" }, [
                                  _c(
                                    "div",
                                    { staticClass: "info_key" },
                                    [
                                      _c("div", {
                                        staticStyle: { width: "11px" },
                                      }),
                                      _c("i", {
                                        staticClass:
                                          "iconfont icon-riqi info_icon",
                                        staticStyle: { "font-size": "17px" },
                                      }),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "dark",
                                            content: "图纸确认",
                                            placement: "bottom",
                                            "popper-class": "texttooltip",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "form_fieldName" },
                                            [_vm._v("图纸确认")]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("div", { staticClass: "info_value" }, [
                                    _vm.drawer.info.editFlag &&
                                    _vm.drawer.info.delFlag != "2" &&
                                    _vm.edit_input == "input_dateStartDraw"
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: { width: "177px" },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.permissionsDateStartDraw(
                                                  "input_dateStartDraw"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("el-date-picker", {
                                              ref: "input_dateStartDraw",
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                type: "datetime",
                                                "picker-options":
                                                  _vm.pickerOptions,
                                                placeholder: "点击添加",
                                                "value-format":
                                                  "yyyy/MM/dd HH:mm:ss",
                                                format: "yyyy/MM/dd",
                                                clearable: false,
                                                "default-time": "00:00:00",
                                              },
                                              on: {
                                                blur: function ($event) {
                                                  return _vm.editTaskChange(
                                                    "drawingDate",
                                                    _vm.drawer.info.drawingDate
                                                  )
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.drawer.info.drawingDate,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.drawer.info,
                                                    "drawingDate",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "drawer.info.drawingDate",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "div",
                                          {
                                            class:
                                              _vm.drawer.info.status != "2"
                                                ? "info_valueEditFlag1"
                                                : "info_value_text",
                                            staticStyle: {
                                              width: "100% !important",
                                              height: "35px",
                                              cursor: "pointer",
                                              "margin-left": "11px",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.permissionsDateStartDraw(
                                                  "input_dateStartDraw"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm.drawer.info.drawingDate
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.drawer.info.drawingDate.substring(
                                                        0,
                                                        10
                                                      )
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        ),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm.drawer.info.proTypeId == "0" &&
                            _vm.corpId ===
                              "ding379884b8b194a55f35c2f4657eb6378f"
                              ? _c("div", { staticClass: "info" }, [
                                  _c(
                                    "div",
                                    { staticClass: "info_key" },
                                    [
                                      _c("div", {
                                        staticStyle: { width: "11px" },
                                      }),
                                      _c("i", {
                                        staticClass:
                                          "iconfont icon-riqi info_icon",
                                        staticStyle: { "font-size": "17px" },
                                      }),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "dark",
                                            content: "预计完成",
                                            placement: "bottom",
                                            "popper-class": "texttooltip",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "form_fieldName" },
                                            [_vm._v("预计完成")]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("div", { staticClass: "info_value" }, [
                                    _vm.edit_input == "input_dateStartPlanEnd"
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: { width: "177px" },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.permissionsDateStartPlanEnd(
                                                  "input_dateStartPlanEnd"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("el-date-picker", {
                                              ref: "input_dateStartPlanEnd",
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                type: "datetime",
                                                "picker-options":
                                                  _vm.pickerOptions,
                                                placeholder: "点击添加",
                                                "value-format":
                                                  "yyyy/MM/dd HH:mm:ss",
                                                format: "yyyy/MM/dd",
                                                clearable: false,
                                                "default-time": "00:00:00",
                                              },
                                              on: {
                                                blur: function ($event) {
                                                  return _vm.editTaskChange(
                                                    "prodPlanEndDate",
                                                    _vm.drawer.info
                                                      .prodPlanEndDate
                                                  )
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.drawer.info
                                                    .prodPlanEndDate,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.drawer.info,
                                                    "prodPlanEndDate",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "drawer.info.prodPlanEndDate",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "div",
                                          {
                                            class:
                                              _vm.drawer.info.status != "2"
                                                ? "info_valueEditFlag1"
                                                : "info_value_text",
                                            staticStyle: {
                                              width: "100% !important",
                                              height: "35px",
                                              cursor: "pointer",
                                              "margin-left": "11px",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.permissionsDateStartPlanEnd(
                                                  "input_dateStartPlanEnd"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm.drawer.info.prodPlanEndDate
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.drawer.info.prodPlanEndDate.substring(
                                                        0,
                                                        10
                                                      )
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        ),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm.drawer.info.formId &&
                            _vm.drawer.info.formId != "0"
                              ? _c("Form", {
                                  ref: "forms",
                                  attrs: {
                                    "form-json": _vm.formJson,
                                    drawer: _vm.drawer,
                                  },
                                  on: {
                                    editTaskChange: _vm.editTaskChange,
                                    checkboxGroup: _vm.checkboxGroup,
                                    closeEditForm: function ($event) {
                                      _vm.edit_input = ""
                                    },
                                  },
                                })
                              : _vm._e(),
                            !_vm.drawer.info.formId ||
                            _vm.drawer.info.formId == "0"
                              ? _c("div", { staticClass: "info" }, [
                                  _c(
                                    "div",
                                    { staticClass: "info_key" },
                                    [
                                      _c("div", {
                                        staticStyle: { "margin-left": "11px" },
                                      }),
                                      _c("i", {
                                        staticClass:
                                          "iconfont icon-describe info_icon",
                                        staticStyle: { "font-size": "14px" },
                                      }),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "dark",
                                            content: "描述",
                                            placement: "bottom",
                                            "popper-class": "texttooltip",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.permissionsChange(
                                                    "describe"
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("描述")]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.drawer.info.editFlag &&
                                  _vm.drawer.info.delFlag != "2" &&
                                  _vm.edit_input == "describe"
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            width: "calc(100% - 102px)",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.permissionsChange(
                                                "describe"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("Describe", {
                                            attrs: {
                                              describes: _vm.drawer.describes,
                                            },
                                            on: { func: _vm.getMsgFormSon },
                                          }),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "div",
                                        {
                                          class: _vm.drawer.info.editFlag
                                            ? "info_valueEditFlag"
                                            : "info_value",
                                          staticStyle: { "min-height": "35px" },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.permissionsChange(
                                                "describe"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "info_value_text",
                                              staticStyle: {
                                                "margin-top": "2px",
                                              },
                                            },
                                            [
                                              _vm.drawer.describes.describe
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "min-height": "35px",
                                                        cursor: "pointer",
                                                      },
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.$httpFormart(
                                                            _vm.drawer.describes
                                                              .describe
                                                          )
                                                        ),
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.drawer.describes
                                                            .describe
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "div",
                                                { staticClass: "file_list" },
                                                _vm._l(
                                                  _vm.drawer.describes.descList,
                                                  function (item, index) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: index,
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.fileLists(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "iconfont icon-wenjian file__icon",
                                                        }),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.fileName
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                ])
                              : _vm._e(),
                            !_vm.drawer.info.formId ||
                            _vm.drawer.info.formId == "0"
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "info",
                                    staticStyle: { "margin-bottom": "20px" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "info_key" },
                                      [
                                        _c("div", {
                                          staticStyle: {
                                            "margin-left": "11px",
                                          },
                                        }),
                                        _c("i", {
                                          staticClass:
                                            "iconfont icon-tag info_icon",
                                        }),
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              content: "标签",
                                              placement: "bottom",
                                              "popper-class": "texttooltip",
                                            },
                                          },
                                          [_c("div", [_vm._v("标签")])]
                                        ),
                                      ],
                                      1
                                    ),
                                    !_vm.drawer.info.editFlag ||
                                    _vm.drawer.info.delFlag == "2"
                                      ? _c(
                                          "div",
                                          { staticClass: "info_value" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.drawer.info
                                                        .labelList &&
                                                      _vm.drawer.info.labelList
                                                        .length > 0,
                                                    expression:
                                                      "drawer.info.labelList&&drawer.info.labelList.length>0",
                                                  },
                                                ],
                                                staticClass: "info_box",
                                                staticStyle: {
                                                  "margin-left": "11px",
                                                },
                                              },
                                              _vm._l(
                                                _vm.drawer.info.labelList,
                                                function (tag, index1) {
                                                  return _c(
                                                    "el-tag",
                                                    {
                                                      key: index1,
                                                      staticStyle: {
                                                        "margin-right": "16px",
                                                      },
                                                      attrs: {
                                                        type: "warning",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(tag.labelName)
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              1
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          { staticClass: "info_value" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "info_box",
                                                staticStyle: {
                                                  "margin-left": "11px",
                                                },
                                              },
                                              [
                                                _vm._l(
                                                  _vm.drawer.info.labelList,
                                                  function (tag, index1) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value:
                                                              _vm.drawer.info
                                                                .labelList &&
                                                              _vm.drawer.info
                                                                .labelList
                                                                .length > 0,
                                                            expression:
                                                              "drawer.info.labelList&&drawer.info.labelList.length>0",
                                                          },
                                                        ],
                                                        key: index1,
                                                        staticClass:
                                                          "info_tags",
                                                      },
                                                      [
                                                        _c(
                                                          "el-tag",
                                                          {
                                                            staticStyle: {
                                                              "margin-right":
                                                                "16px",
                                                            },
                                                            style:
                                                              "color:" +
                                                              tag.color +
                                                              ";background:" +
                                                              _vm.convertHex(
                                                                tag.color,
                                                                10
                                                              ),
                                                            attrs: {
                                                              type: "warning",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                tag.labelName
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "iconfont icon-shanchu del_icon",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.delTagsChange(
                                                                tag
                                                              )
                                                            },
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                _c(
                                                  "el-popover",
                                                  {
                                                    attrs: {
                                                      placement: "bottom",
                                                      width: "540",
                                                      trigger: "click",
                                                    },
                                                  },
                                                  [
                                                    _c("TagsList", {
                                                      attrs: {
                                                        "tags-objects":
                                                          _vm.tagsObject,
                                                        "tag-lists":
                                                          _vm.tagList,
                                                      },
                                                    }),
                                                    _c("i", {
                                                      staticClass:
                                                        "iconfont icon-jiahao2fill add_icon",
                                                      style:
                                                        _vm.drawer.info
                                                          .labelList &&
                                                        _vm.drawer.info
                                                          .labelList.length > 0
                                                          ? "margin: 0 24px;"
                                                          : "margin: 0",
                                                      attrs: {
                                                        slot: "reference",
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.tagListchange,
                                                      },
                                                      slot: "reference",
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              2
                                            ),
                                          ]
                                        ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c("el-tab-pane", { attrs: { label: "成员", name: "2" } }, [
                      _c(
                        "div",
                        {
                          staticClass: "info_conts",
                          style: "height:" + _vm.height + "px",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "info" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "info_key",
                                  staticStyle: { width: "108px" },
                                },
                                [
                                  _c("i", {
                                    staticClass: "iconfont icon-task info_icon",
                                    staticStyle: { "font-size": "12px" },
                                  }),
                                  _c("div", [
                                    _vm._v(
                                      "管理员（" +
                                        _vm._s(
                                          _vm.drawer.manageUsers.length > 0
                                            ? _vm.drawer.manageUsers.length
                                            : 0
                                        ) +
                                        "）"
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "dark",
                                    "popper-class": "texttooltip",
                                    content: "管理员可以管理项目内任务",
                                    placement: "right",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "iconfont icon-shuoming info_icon info_icon_show",
                                    staticStyle: { "font-size": "14px" },
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm.drawer.info.editFlag &&
                          _vm.drawer.info.delFlag != "2"
                            ? _c(
                                "div",
                                { staticClass: "users_personnel" },
                                [
                                  _vm._l(
                                    _vm.drawer.manageUsers,
                                    function (item, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass: "user_personnel",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "info_personnel",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.contactCh(
                                                    _vm.drawer.manageUsers,
                                                    1
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              item.avatar != "" &&
                                              item.avatar !== null
                                                ? _c("img", {
                                                    staticClass:
                                                      "info_personnel_surname",
                                                    attrs: { src: item.avatar },
                                                  })
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "info_personnel_surname",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.name.substring(
                                                            0,
                                                            1
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                              _vm.channel === "wechat"
                                                ? _c(
                                                    "div",
                                                    [
                                                      _c("ww-open-data", {
                                                        attrs: {
                                                          type: "userName",
                                                          openid: item.name,
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _c("div", [
                                                    _vm._v(_vm._s(item.name)),
                                                  ]),
                                            ]
                                          ),
                                          _c("i", {
                                            staticClass:
                                              "iconfont icon-shanchu del_icon",
                                            on: {
                                              click: function ($event) {
                                                return _vm.delUsers(
                                                  _vm.drawer.manageUsers,
                                                  index,
                                                  1
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      )
                                    }
                                  ),
                                  _c("i", {
                                    staticClass:
                                      "iconfont icon-jiahao2fill add_icon",
                                    style:
                                      _vm.drawer.manageUsers.length > 0
                                        ? "margin-left:34px"
                                        : "",
                                    on: {
                                      click: function ($event) {
                                        return _vm.contactCh(
                                          _vm.drawer.manageUsers,
                                          1
                                        )
                                      },
                                    },
                                  }),
                                ],
                                2
                              )
                            : _c(
                                "div",
                                { staticClass: "users_personnel" },
                                _vm._l(
                                  _vm.drawer.manageUsers,
                                  function (item, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "info_personnel",
                                      },
                                      [
                                        item.avatar != "" &&
                                        item.avatar !== null
                                          ? _c("img", {
                                              staticClass:
                                                "info_personnel_surname",
                                              attrs: { src: item.avatar },
                                            })
                                          : _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "info_personnel_surname",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.name.substring(0, 1)
                                                  )
                                                ),
                                              ]
                                            ),
                                        _vm.channel === "wechat"
                                          ? _c(
                                              "div",
                                              [
                                                _c("ww-open-data", {
                                                  attrs: {
                                                    type: "userName",
                                                    openid: item.name,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _c("div", [
                                              _vm._v(_vm._s(item.name)),
                                            ]),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                          _c(
                            "div",
                            { staticClass: "info" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "info_key",
                                  staticStyle: { width: "122px" },
                                },
                                [
                                  _c("i", {
                                    staticClass: "iconfont icon-task info_icon",
                                    staticStyle: { "font-size": "12px" },
                                  }),
                                  _c("div", [
                                    _vm._v(
                                      "项目成员（" +
                                        _vm._s(
                                          _vm.drawer.memberUsers.length > 0
                                            ? _vm.drawer.memberUsers.length
                                            : 0
                                        ) +
                                        "）"
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "dark",
                                    "popper-class": "texttooltip",
                                    content: "项目成员可以查看项目内任务",
                                    placement: "right",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "iconfont icon-shuoming info_icon info_icon_show",
                                    staticStyle: { "font-size": "14px" },
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm.drawer.info.editFlag &&
                          _vm.drawer.info.delFlag != "2"
                            ? _c(
                                "div",
                                { staticClass: "users_personnel" },
                                [
                                  _vm._l(
                                    _vm.drawer.memberUsers,
                                    function (item, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass: "user_personnel",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "info_personnel",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.contactCh(
                                                    _vm.drawer.memberUsers,
                                                    2
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              item.avatar != "" &&
                                              item.avatar !== null
                                                ? _c("img", {
                                                    staticClass:
                                                      "info_personnel_surname",
                                                    attrs: { src: item.avatar },
                                                  })
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "info_personnel_surname",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.name.substring(
                                                            0,
                                                            1
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                              _vm.channel === "wechat"
                                                ? _c(
                                                    "div",
                                                    [
                                                      _c("ww-open-data", {
                                                        attrs: {
                                                          type: "userName",
                                                          openid: item.name,
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _c("div", [
                                                    _vm._v(_vm._s(item.name)),
                                                  ]),
                                            ]
                                          ),
                                          _c("i", {
                                            staticClass:
                                              "iconfont icon-shanchu del_icon",
                                            on: {
                                              click: function ($event) {
                                                return _vm.delUsers(
                                                  _vm.drawer.memberUsers,
                                                  index,
                                                  2
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      )
                                    }
                                  ),
                                  _c("i", {
                                    staticClass:
                                      "iconfont icon-jiahao2fill add_icon",
                                    style:
                                      _vm.drawer.memberUsers.length > 0
                                        ? "margin-left:34px"
                                        : "",
                                    on: {
                                      click: function ($event) {
                                        return _vm.contactCh(
                                          _vm.drawer.memberUsers,
                                          2
                                        )
                                      },
                                    },
                                  }),
                                ],
                                2
                              )
                            : _c(
                                "div",
                                { staticClass: "users_personnel" },
                                _vm._l(
                                  _vm.drawer.memberUsers,
                                  function (item, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "info_personnel",
                                      },
                                      [
                                        item.avatar != "" &&
                                        item.avatar !== null
                                          ? _c("img", {
                                              staticClass:
                                                "info_personnel_surname",
                                              attrs: { src: item.avatar },
                                            })
                                          : _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "info_personnel_surname",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.name.substring(0, 1)
                                                  )
                                                ),
                                              ]
                                            ),
                                        _vm.channel === "wechat"
                                          ? _c(
                                              "div",
                                              [
                                                _c("ww-open-data", {
                                                  attrs: {
                                                    type: "userName",
                                                    openid: item.name,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _c("div", [
                                              _vm._v(_vm._s(item.name)),
                                            ]),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                          _c("div", { staticClass: "info" }, [
                            _c(
                              "div",
                              {
                                staticClass: "info_key",
                                staticStyle: { width: "122px" },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "iconfont icon-chengyuan-tianjia info_icon",
                                  staticStyle: { "font-size": "15px" },
                                }),
                                _c("div", [_vm._v("成员范围")]),
                              ]
                            ),
                          ]),
                          _vm.drawer.info.editFlag &&
                          _vm.drawer.info.delFlag != "2"
                            ? _c("div", { staticClass: "users_personnel" }, [
                                _c(
                                  "div",
                                  { staticClass: "info_personnel" },
                                  [
                                    _c(
                                      "el-radio-group",
                                      {
                                        on: { change: _vm.statusChange },
                                        model: {
                                          value: _vm.drawer.info.autoAddMember,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.drawer.info,
                                              "autoAddMember",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "drawer.info.autoAddMember",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-radio",
                                          { attrs: { label: "0" } },
                                          [_vm._v("任务成员默认加入")]
                                        ),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: "1" } },
                                          [_vm._v("手动添加项目成员")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ])
                            : _c("div", { staticClass: "users_personnel" }, [
                                _c(
                                  "div",
                                  { staticClass: "info_personnel" },
                                  [
                                    _c(
                                      "el-radio-group",
                                      {
                                        attrs: { disabled: "" },
                                        model: {
                                          value: _vm.drawer.info.autoAddMember,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.drawer.info,
                                              "autoAddMember",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "drawer.info.autoAddMember",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-radio",
                                          { attrs: { label: "0" } },
                                          [_vm._v("任务成员默认加入")]
                                        ),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: "1" } },
                                          [_vm._v("手动添加项目成员")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                        ]
                      ),
                    ]),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialogs", {
        ref: "drawersDialog",
        attrs: { drawer: _vm.drawer, proid: _vm.proid },
        on: {
          fatherMethods: _vm.openDrawer,
          func: _vm.cover,
          archiveMethod: _vm.archiveChange,
          proDelChange: _vm.proDelChange,
        },
      }),
      _c("VideoPreview", {
        attrs: { visible: _vm.showVideo, url: _vm.videoUrl },
        on: {
          "update:visible": [
            function ($event) {
              _vm.showVideo = $event
            },
            function (val) {
              return _vm.console.log("visible 更新为:", val)
            },
          ],
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }